module.exports = __webpack_public_path__ + "img/26377610000100.659f384f.png";